module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [(_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('username')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your email")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a password")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('form', {
    attrs: {
      "name": "login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "username",
      "data-vv-delay": "2000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "password",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Login",
      "name": "submitButton",
      "title": "Login"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Not a member? "), _c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Click here to register for free.")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        path: '/forgotpassword'
      }
    }
  }, [_vm._v(" Forgot Password?")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        Email: "), _c('br'), _vm._v("\n        Password:\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b7dd3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 299
// module chunks = 1